import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Resources from "../../../data/services/resources";
import TasksSettingsGeneralTab from "./tasks-settings-general-tab";
import TasksSettingsAutoTasksTab from './tasks-settings-auto-tasks'
import Page from "../../../common/components/layout/layout-components/page";
import PageHeader from "../../../common/components/layout/layout-components/page/page-header";
import PageHeaderInfo from "../../../common/components/layout/layout-components/page/page-header-info";
import NavResponsive from "../../../common/components/nav-responsive";
import Layout from "../../../common/components/layout";
import {checkPerm} from '../../../common/util/util-helpers'
import {READ_PERM} from "../../../util/util-constants";
import ModalConfirm from "../../../common/components/modal/modal-confirm";

export default function TasksSettingsView({translate, match, history, location}) {
    const dispatch = useDispatch();
    const ui = useSelector((state) => state.ui);
    const user = useSelector((state) => state.user);
    const contactResource = useSelector((state) => state.contactResource);
    const resource = useSelector((state) => state.resource);

    const [tabs, setTabs] = useState(getTabs());
    const currentTab = tabs.find(tab => tab.current);
    const [isTabDirty, setIsTabDirty] = useState(false);
    const [isDirtyStateWarningModalOpen, setIsDirtyStateWarningModalOpen] = useState(false);
    const [tabClicked, setTabClicked] = useState("");

    const handleTabChange = (resource) => {
        if (currentTab.resource === resource) {
            return false;
        }

        if (isTabDirty) {
            setIsDirtyStateWarningModalOpen(true);
            setTabClicked(resource)
        } else {
            setTabs(
                tabs.map((it) => {
                    it.current = it.resource === resource;
                    return it
                })
            )
        }
    }

    return (
        <Layout
            ui={ui}
            user={user}
            match={match}
            history={history}
            location={location}
            translate={translate}
            dispatch={dispatch}
            contactResource={contactResource}
            isDirty={isTabDirty}
            isAccessible={!(resource.errorStatus === 2)}
            hasFooter
        >
            <Page>
                <PageHeader
                    title={translate('page.heading.TasksSettings')}
                    afterTitle={(
                        <PageHeaderInfo
                            dispatch={dispatch}
                        />
                    )}
                />

                <NavResponsive
                    tabs={tabs}
                    onTabChange={handleTabChange}
                    translate={translate}
                />

                {currentTab.name === 'general' && (
                    <TasksSettingsGeneralTab
                        translate={translate}
                        setIsTabDirty={setIsTabDirty}
                        resourcePath={currentTab.resource}
                    />
                )}

                {currentTab.name === 'auto-tasks' && (
                    <TasksSettingsAutoTasksTab
                        translate={translate}
                        setIsTabDirty={setIsTabDirty}
                        resourcePath={currentTab.resource}
                    />
                )}
            </Page>

            <ModalConfirm
                show={isDirtyStateWarningModalOpen}
                type="default"
                onClose={() => setIsDirtyStateWarningModalOpen(false)}
                onConfirm={() => {
                    setTabs(
                        tabs.map((it) => {
                            it.current = it.resource === tabClicked;
                            return it
                        })
                    );
                    setIsDirtyStateWarningModalOpen(false);
                    setIsTabDirty(false);
                }}
                closeButtonLabel={translate("btn.stay_on_current_tab")}
                buttonLabel={translate("text.Continue")}
                title={translate('dialog_heading.unsaved_changes_on_tab')}
                translate={translate}
            >
                <p className="text-base">{translate('text.changes_on_tab')}</p>
                <p className="text-base">{translate('text.changes_will_be_lost')}</p>
            </ModalConfirm>
        </Layout>
    )
}

const getTabs = () => {
    return [
        {
            name: 'general',
            resource: Resources.TasksSettings,
            current: true,
            visible: checkPerm(Resources.TasksSettings, READ_PERM)
        },
        {
            name: 'auto-tasks',
            resource: Resources.TasksGroupDefaults,
            current: false,
            visible: checkPerm(Resources.TasksGroupDefaults, READ_PERM)
        }
    ]
}
